import { render, staticRenderFns } from "./SitePageSearch.vue?vue&type=template&id=0f1fffe8&"
import script from "./SitePageSearch.vue?vue&type=script&lang=js&"
export * from "./SitePageSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports